import { useCallback, useState } from "react";

export const useHighlightComponent = (storageKey?: string) => {
  const [showHint, setShowHint] = useState(() =>
    storageKey ? localStorage.getItem(storageKey) !== "true" : true,
  );

  const dismissHint = useCallback(() => {
    setShowHint(false);
    if (storageKey) {
      localStorage.setItem(storageKey, "true");
    }
  }, [storageKey]);

  const hintClassName = showHint ? "animate-nudge-bounce" : "";

  return { showHint, dismissHint, hintClassName };
};
